
import { Alert } from 'reactstrap';

const InfoBanner = () => {
    return (
        <Alert color='info'>
            <strong>Please note</strong> - certain historical data relating to assets owned by AerCap prior to the acquisition of GECAS may not be available. Please contact <a href="mailto:Contracts@aercap.com">Contracts@aercap.com</a> if you require further details.
        </Alert>
    );
};

export default InfoBanner;
